module.exports = __webpack_public_path__ + "static/media/phone_icon.f892c7f1.svg";